export const EXHIBITION_THEME_MS = 650;

export function initialExhibitionDarkMode() {
  if (typeof document === 'undefined') return false;
  // The page sets the root theme before the body and its theme controls mount.
  return document.documentElement.classList.contains('dark-mode')
    || Boolean(document.body?.classList.contains('dark-mode'));
}

const timers = new WeakMap();
export function beginExhibitionTheme(element) {
  if (!element) return;
  clearTimeout(timers.get(element));
  element.style.setProperty('--ex-theme-duration', `${EXHIBITION_THEME_MS}ms`);
  element.setAttribute('data-exhibition-theme-transition', '');
  timers.set(element, setTimeout(() => {
    element.removeAttribute('data-exhibition-theme-transition');
    timers.delete(element);
  }, EXHIBITION_THEME_MS + 50));
}
